<template>
  <!-- START : Address section -->
  <div>
    <h3>{{ $t('profileAddressSection') }}</h3>
    <!-- For each address on boarding profile -->
    <div v-for="address in form.addresses" :key="address.did">
      <h4>{{ address.name }}</h4>
      <WCAccountSettingsAddressInput
        :address="address"
        @input="addressChanged"
        @update:valid="formUpdateValidCheck"
        :did="address.did"
      />
      <WCCheckbox
        v-if="address.billTo"
        class="my-3"
        label="Default Billing Address"
        v-model="address.billTo.value"
        @change="clearOthers(address.did, 'billTo')"
      />

      <WCCheckbox
        v-if="address.shipTo"
        class="my-3"
        label="Default Shipping Address"
        v-model="address.shipTo.value"
        @change="clearOthers(address.did, 'shipTo')"
      />
    </div>
  </div>
  <!-- END : Address section -->
</template>

<script>
/* eslint-disable func-names */
import WCAccountSettingsAddressInput from '@/modules/user/components/WCAccountSettings/components/WCAccountSettingsAddressInput/WCAccountSettingsAddressInput.vue';
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';

export default {
  name: 'WCAddressInfoSectionForm',
  components: {
    WCAccountSettingsAddressInput,
    WCCheckbox,
  },
  emits: ['formChanged', 'formUpdateValid'],
  props: {
    me: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        addresses: this.me.addresses,
      },
    };
  },

  methods: {
    /**
     * Method to find index of the updated object from child and modify parent form address
     * @param {Object} addressObject
     */
    addressChanged(addressObject) {
      const indexToReplace = this.form.addresses.findIndex(addr => addr.did === addressObject.did);
      if (indexToReplace !== -1) {
        this.form.addresses.splice(indexToReplace, 1, addressObject);
      }
      this.$emit('formChanged', this.form);
    },
    /**
     * Method to emit validity of form fields
     */
    formUpdateValidCheck($event, did) {
      this.$emit('formUpdateValid', $event, did);
    },

    clearOthers(did, tag) {
      this.form.addresses.forEach(item => {
        if (item.did !== did) {
          if (item[tag]) {
            // eslint-disable-next-line no-param-reassign
            item[tag].value = false;
          }
        }
      });
    },
  },
};
</script>
